import Base from '../base.js'

export default class Pools extends Base {
  constructor () {
    super('pool/')
  }
}
